export const USER = 'us3r'
export const ADMIN= '4dm1n'
export const SUPERADMIN= 's3p3r4d1n'
export const URL = 'https://apie-pied.vercel.app/'